
import { createComponent, reactive, computed } from "@vue/composition-api";

type Props = {
  missCount: number;
};

export default createComponent({
  props: {
    missCount: {
      type: Number,
      default: 0,
    },
  },
  setup(props: Props) {
    const state = reactive({
      missCount: computed(() => props.missCount),
    });

    return {
      state,
    };
  },
});
